import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { IApplicationState } from "../store/state/app-state";
import store from "../store";
import { AuthActionType } from "../shared/enums/auth-action-types";
import { env } from "../env";

declare module "axios" {
  export interface AxiosRequestConfig {
    showLoader: boolean;
  }
}

export const showLoader = () => {
  const loaderDiv = document.getElementById("loader");

  if (loaderDiv) {
    loaderDiv.style.display = "flex";
    loaderDiv.style.visibility = "visible";
  }
};

export const hideLoader = () => {
  const loaderDiv = document.getElementById("loader");

  if (loaderDiv) {
    loaderDiv.style.display = "none";
    loaderDiv.style.visibility = "hidden";
  }
};

axios.interceptors.request.use(
  (config: any) => {
    const storeData: IApplicationState = store.getState();
    if (config.url) {
      config.url = env.REACT_APP_API_BASE_URL + config.url;
    }
    console.log(config.url);
    if (storeData?.GeneralData?.showLoader) {
      showLoader();
    } else store.dispatch({ type: AuthActionType.SHOW_LOADER, payload: true });
    return config;
  },
  (error: AxiosError) => {
    hideLoader();
  }
);

axios.interceptors.response.use(
  (response: AxiosResponse | any) => {
    hideLoader();
    return response;
  },
  (error: AxiosError) => {
    hideLoader();
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
};
